"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Capitalize the given string.
 *
 * @Param {string} text = The text to capitalize.
 *
 * @Example
 *
 *   capitalize('BANANA')
 *   //=> "Banana"
 */
function capitalize(text) {
    return text.charAt(0).toUpperCase() + text.substring(1).toLowerCase();
}
exports.capitalize = capitalize;
//# sourceMappingURL=capitalize.js.map